/*
  Split test `cart-express-checkout`: fit Shopify's three wallet buttons into
  one row at the checkout button's width.

  Shopify's grid decides between a row and a stack from its own container's
  width, and each button has a hard 100px min-width, so a row needs 322px. The
  drawer offers 283px at a 375px viewport. The form is therefore given 322px and
  zoomed down to the width the checkout button renders at, which is the one
  number CSS could not reach: container query units resolve to the footer
  column (307px), not to the button (283px).

  Timing is the whole job. The <form> is in the server HTML, but Shopify's
  component draws into it a beat later. Measured at 375px: the footer went to
  178px at 163ms as the stack drew, then to 37px at 409ms when this file ran,
  which is a visible jolt. So the sizing is applied the moment the form exists,
  before the component boots, and the wallets lay out as a row on their first
  paint. The height is reserved at the same moment so the footer does not grow
  from nothing either.

  Fails open. Anything missing or out of range and the styling is removed, which
  leaves Shopify's own stack exactly as it ships.
*/
(function () {
  'use strict';

  /* 3 buttons at Shopify's 100px minimum, plus its two 10px gaps. */
  var NEEDED = 322;
  /* The row's own height at zoom 1, reserved so the footer never grows into it. */
  var ROW_HEIGHT = 42;
  var ATTR = 'data-wb-express-fit';

  function release(ex) {
    ex.removeAttribute(ATTR);
    ex.style.removeProperty('--wb-express-needed');
    ex.style.removeProperty('--wb-express-zoom');
    ex.style.removeProperty('--wb-express-row');
  }

  function apply() {
    var ex = document.querySelector('.cart-drawer__express');
    if (!ex) return;

    var form = ex.querySelector('.shopify-cart-form');
    var button = document.querySelector('.cart-drawer__checkout');
    if (!form || !button) return release(ex);

    /* Desktop already has room for the row at its natural size. */
    if (window.matchMedia('(min-width: 1025px)').matches) return release(ex);

    /*
      The button is a sibling of the zoomed form, so its width does not depend
      on the zoom. Nothing has to be unset to measure it, which is what keeps
      this from forcing a reflow every time the drawer mutates.
    */
    var target = button.getBoundingClientRect().width;
    if (!target || target >= NEEDED) return release(ex);

    var zoom = target / NEEDED;

    /* Already correct. Doing nothing here is what stops the flicker. */
    if (ex.getAttribute(ATTR) === String(zoom)) return;

    ex.style.setProperty('--wb-express-needed', NEEDED + 'px');
    ex.style.setProperty('--wb-express-zoom', String(zoom));
    ex.style.setProperty('--wb-express-row', ROW_HEIGHT + 'px');
    ex.setAttribute(ATTR, String(zoom));
  }

  function watch() {
    /*
      Applied straight from the observer rather than on a timer. A mutation
      callback runs before the next paint, so a drawer replaced by a section
      render is sized before anything is drawn into it. A debounce here is what
      let the stack paint first.

      Scoped to the drawer, not the document, so the wallets' own iframes do not
      keep waking this up.
    */
    var drawer = document.querySelector('cart-drawer') || document.body;
    new MutationObserver(apply).observe(drawer, { childList: true, subtree: true });
    window.addEventListener('resize', apply);
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
